import $axios from "../api/accessor";
import { $api } from "../api/api";

export const SpecialOrderService = {
  async getCountries() {
    const response = await $axios.get($api("special_order_countries")).catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async getOrders(country_id: number, url?: string, page?: number, archive?: string) {
    const params: Record<string, any> = { country_id };
    if (page && page > 1) params.page = page;
    if (archive) params.archive = archive;
    const endpoint = url || $api("special_order_get_orders", params);
    const response = await $axios.get(endpoint).catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async addOrder(country_id: number, payload: any) {
    const response = await $axios
      .post($api("special_order_add", { country_id }), payload)
      .catch((err) => { throw err.response ? err.response.data : err.message; });
    return response;
  },

  async payOrder(country_id: number, order_id: number, payload: any) {
    const response = await $axios
      .post($api("special_order_pay", { country_id, order_id }), payload)
      .catch((err) => { throw err.response ? err.response.data : err.message; });
    return response;
  },

  async getOrderForUpdate(country_id: number, order_id: number) {
    const response = await $axios
      .get($api("special_order_get_update", { country_id, order_id }))
      .catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async updateOrder(country_id: number, order_id: number, payload: any) {
    const response = await $axios
      .post($api("special_order_update", { country_id, order_id }), payload)
      .catch((err) => { throw err.response ? err.response.data : err.message; });
    return response;
  },

  async updatePartner(country_id: number, order_id: number, payload: any) {
    const response = await $axios
      .put($api("special_order_update_partner", { country_id, order_id }), payload)
      .catch((err) => { throw err.response ? err.response.data : err.message; });
    return response;
  },

  async cancelPartner(country_id: number, order_id: number) {
    const response = await $axios
      .post($api("special_order_cancel_partner", { country_id, order_id }), {})
      .catch((err) => { throw err.response ? err.response.data : err.message; });
    return response;
  },

  async deleteOrder(country_id: number, order_id: number) {
    const response = await $axios
      .delete($api("special_order_delete", { country_id, order_id }))
      .catch((err) => { throw err.response ? err.response.data : err.message; });
    return response;
  },

  async showGroupOrders(country_id: number, group_id: string) {
    const response = await $axios
      .get($api("special_order_show", { country_id }), { params: { group_id } })
      .catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async calculate(country_id: number, payload: any) {
    const response = await $axios
      .post($api("special_order_calculate", { country_id }), payload)
      .catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async getSettings(country_id: number) {
    const response = await $axios
      .get($api("special_order_settings", { country_id }))
      .catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async getBalance() {
    const response = await $axios
      .get($api("special_order_balance"))
      .catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },

  async getBalanceLogs() {
    const response = await $axios
      .get($api("special_order_balance_logs"))
      .catch((err) => err.response);
    return { data: response?.data, status: response?.status };
  },
};
